<template>
    <div class="article white_bg">
        <banner-module ref="bannerModule"></banner-module>
            <van-tabs v-model="activeType" @click="changeTab" sticky>
                <van-tab :title="item.tabName" v-for="item in tabColumn" :key="item.type">
                    <div class="paddingH12">
<!--                        <span class="title paddingT8 paddingB8">-->
<!--                            {{item.data.title}}-->
<!--                        </span>-->
                        <div class="article" v-html="item.data.content"></div>
                    </div>

                    <!-- 浮动模块 -->
                    <div class="floatingPanel">
                        <div class="inner">
                            <div class="van-clearfix flexLayout">

                                <div style="width: 151px">
                                    <a class="phoneLink i" v-show="showPhone" @click="call(item.data.extra.phone)">
                                        {{getPhone(item)}}
                                    </a>
                                </div>
                                <div style="width: 48px">
                                    <span class="callIcon " @click="showTip('phone')"></span>
                                </div>

                            </div>
                            <div class="van-clearfix flexLayout marginT8" style="position: relative">

                                <div style="width: 151px">
                                    <div class="qr_bg i" v-show="showQr">
                                        <img :src="getImg(item)"
                                             style="width: 109px;height: 109px; margin-right: 24px;margin-top: 13px;border-radius: 8px;">
                                    </div>
                                </div>
                                <div style="width: 48px">
                                    <span class="wxIcon " @click="showTip('qr')"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 浮动模块 -->

                </van-tab>
            </van-tabs>

    </div>
</template>

<script>
    import { Toast} from 'vant';
    import {Tab, Tabs} from 'vant';
    import article from '@pages/popularize/textContentApi';
    import bannerModule from "@comp/bannerModule";

    // style
    import '../popularize.scss';

    // util
    import wechatHelper from '@util/wechatHelper';
    import appHelper from '@util/appHelper';

    export default {
        props: {},
        components: {'van-tab': Tab, 'van-tabs': Tabs, bannerModule},
        data() {
            return {
                activeType: 0,
                showQr: false,
                showPhone: false,
                tabColumn: [
                    {
                        tabName: '创意美术',
                        type: 1,
                        data: {
                            title: '',
                            content: '',
                            extra: {
                                phone: '',
                                wxImg: ''
                            }
                        }
                    },
                    {
                        tabName: '感统',
                        type: 2,
                        data: {
                            title: '',
                            content: '',
                            extra: {
                                phone: '',
                                wxImg: ''
                            }
                        }
                    }, {
                        tabName: 'STEAM',
                        type: 3,
                        data: {
                            title: '',
                            content: '',
                            extra: {
                                phone: '',
                                wxImg: ''
                            }
                        }
                    }, {
                        tabName: '中国传统文化',
                        type: 4,
                        data: {
                            title: '',
                            content: '',
                            extra: {
                                phone: '',
                                wxImg: ''
                            }
                        }
                    }, {
                        tabName: '幼小衔接',
                        type: 5,
                        data: {
                            title: '',
                            content: '',
                            extra: {
                                phone: '',
                                wxImg: ''
                            }
                        }
                    },
                ]
            };
        },
        mounted() {
            let type = (this.$route.params.type);
            if (type != null) {
                this.activeType = type - 1
            }
            this.changeTab(this.activeType, '');

            this.$refs.bannerModule.loadAd({
                typeEnum: 'POPULARIZE_EDU',
                limit: 8
            });
        },
        methods: {
            changeTab(name, title) {
                let type = this.tabColumn[name].type;
                const me = this;
                article.get(type).then(re => {
                    if (null != re) {
                        if (null != re.data.data) {
                            me.tabColumn[name].data = re.data.data
                            if ('' != re.data.data.extraInfo) {
                                try {
                                    me.tabColumn[name].data.extra = JSON.parse(re.data.data.extraInfo)
                                } catch (e) {

                                }
                            }
                            this.setWechatShare(re.data.data.title);
                        } else {
                            Toast('暂无内容～')
                        }
                    }
                }).catch(err => {
                    Toast('网络错误～')
                })
            },
            getImg: function (item) {
                if (item.data.extra != null) {
                    return item.data.extra.wxImg
                }

                return '';
            },
            getPhone: function (item) {
                if (item.data.extra != null) {
                    return item.data.extra.phone
                }

                return '';

            },

            showTip(type) {
                if (type == 'phone') {
                    this.showPhone = !this.showPhone
                    this.showQr = false;
                } else if (type == 'qr') {
                    this.showQr = !this.showQr
                    this.showPhone = false
                }

            },
            call(phone) {
                appHelper.redirect('tel://' + phone);
            },
            setWechatShare: function (title) {

                let wechatShareOptions = {
                    // title: title,
                    title: appHelper.getTitle(),
                    // desc    : desc,
                    link: location.href,
                    imgUrl: appHelper.getAppIcon() // 分享图标
                };

                wechatHelper.setShare(wechatShareOptions);
            }
        }
    };
</script>


<style lang="scss" scoped>
.article {
    img {
        max-width: 100%;
    }
}
</style>
